module.exports = __webpack_public_path__ + "img/the-netherlands-other-heart-diseases-female.e276bbc7.png";